import { render, staticRenderFns } from "./ZxFawuContractDetail.vue?vue&type=template&id=38478e60&scoped=true&"
import script from "./ZxFawuContractDetail.vue?vue&type=script&lang=js&"
export * from "./ZxFawuContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZxFawuContractDetail.vue?vue&type=style&index=0&id=38478e60&scoped=true&lang=css&"
import style1 from "./ZxFawuContractDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38478e60",
  null
  
)

export default component.exports